import { render, staticRenderFns } from "./EditSensorDecoderAlarms.vue?vue&type=template&id=1ba0185c"
import script from "./EditSensorDecoderAlarms.vue?vue&type=script&lang=js"
export * from "./EditSensorDecoderAlarms.vue?vue&type=script&lang=js"
import style0 from "./EditSensorDecoderAlarms.vue?vue&type=style&index=0&id=1ba0185c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports